/**
 * Toolbar entry for accounts: "Sign in" when signed out, otherwise the
 * account's initial linking to /account (API keys, agents, sign out).
 */
export function mountAccountButton({window}) {
  const document = window.document;
  let button = null;
  let user;
  let disposed = false;
  const render = () => {
    if (disposed || user === undefined) return;
    if (!button?.isConnected) {
      const anchor = document.querySelector('[data-studio-agents]') ?? document.querySelector('[data-local-models]');
      if (!anchor) return;
      button = document.createElement('a');
      button.dataset.studioAccount = '';
      anchor.after(button);
    }
    const next = window.location.pathname + window.location.search;
    const href = user ? '/account' : `/login?next=${encodeURIComponent(next)}`;
    if (button.getAttribute('href') !== href) button.setAttribute('href', href);
    const label = user ? (user.name || user.email || 'Account').trim() : 'Sign in';
    const text = user ? label.slice(0, 1).toUpperCase() : 'Sign in';
    if (button.textContent !== text) button.textContent = text;
    button.title = user ? `Signed in as ${user.email}. Account, agent keys and sign out.` : 'Sign in to save projects and connect agents';
    button.setAttribute('aria-label', user ? `Account: ${user.email}` : 'Sign in');
    button.dataset.signedIn = String(Boolean(user));
  };
  const refresh = async () => {
    try {
      const response = await window.fetch('/api/auth/session', {cache: 'no-store'});
      user = response.ok ? (await response.json())?.user ?? null : null;
    } catch { user = user ?? null; }
    render();
  };
  const observer = new window.MutationObserver(render);
  observer.observe(document.documentElement, {childList: true, subtree: true});
  const onFocus = () => void refresh();
  window.addEventListener('focus', onFocus);
  void refresh();
  return {dispose() { disposed = true; observer.disconnect(); window.removeEventListener('focus', onFocus); button?.remove(); }};
}
